export default __webpack_public_path__ + "static/media/finalCairo.4e840ba2.jpg";